const VERSION = '2.0.5b'
export default VERSION
